/**
 * Corrige un bug de accesibilidad de slick 1.8.x.
 *
 * initADA() marca todos los slides con aria-hidden="true" + tabindex="-1", y
 * despues le devuelve tabindex="0" al slide buscandolo POR INDICE
 * ($slides.eq(currentSlide)), mientras que activateADA() quita el aria-hidden
 * solo a .slick-active. Con fade:true o infinite:true (que agrega clones) esos
 * dos no siempre son el mismo elemento, asi que queda un slide focuseable y
 * oculto para lectores de pantalla al mismo tiempo. Chrome lo rechaza con
 * "Blocked aria-hidden on an element because its descendant retained focus".
 *
 * No se puede corregir desde los eventos de slick porque los aplica DESPUES de
 * emitirlos:
 *
 *   e && t.$slider.trigger("init",[t]), !0===t.options.accessibility && t.initADA()
 *
 * Por eso se usa un MutationObserver sobre aria-hidden/tabindex: se dispare
 * slick en el orden que se dispare, la correccion llega despues.
 *
 * Regla unica: lo que esta aria-hidden no puede recibir foco. El slide visible
 * no se toca, asi que la navegacion por teclado de slick sigue funcionando.
 */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href],area[href],input,button,select,textarea,iframe,[contenteditable],[tabindex]';

  // Idempotente: solo actua si existe la combinacion invalida, asi que las
  // mutaciones que genera no se realimentan.
  function fixSlide(el) {
    if (!el || el.nodeType !== 1 || !el.classList || !el.classList.contains('slick-slide')) return;
    if (el.getAttribute('aria-hidden') !== 'true') {
      // Slide visible: se le devuelve el tab stop que slick pretende darle.
      // Hace falta porque initADA() asigna tabindex="0" por indice y
      // activateADA() destapa por .slick-active: cuando no coinciden, el slide
      // que queda visible puede terminar sin tabindex despues de que se lo
      // quitamos mientras estaba oculto.
      if (el.getAttribute('tabindex') !== '0') el.setAttribute('tabindex', '0');
      return;
    }
    // Se QUITA el tabindex, no se pone en -1: con tabindex="-1" el div sigue
    // recibiendo foco por click y por .focus(), que es como se llega al estado
    // que Chrome bloquea. Sin el atributo, el contenedor no es focuseable de
    // ninguna forma. slick bindea keydown.slick en $list, $dots y las flechas,
    // nunca en los slides, y al slide visible no se le toca el tabindex, asi
    // que la navegacion por teclado no cambia.
    if (el.hasAttribute('tabindex')) el.removeAttribute('tabindex');
    var kids = el.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].getAttribute('tabindex') !== '-1') kids[i].setAttribute('tabindex', '-1');
    }
  }

  function sweep() {
    var slides = document.querySelectorAll('.slick-slide');
    for (var i = 0; i < slides.length; i++) fixSlide(slides[i]);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        // el atributo puede cambiar en el slide o en un hijo focuseable
        fixSlide(t.classList && t.classList.contains('slick-slide') ? t : (t.closest ? t.closest('.slick-slide') : null));
      }
    }).observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex']
    });
  }

  // El observer solo ve cambios futuros, asi que hace falta una pasada inicial
  // por si algun slider ya se inicializo antes de este script.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  window.addEventListener('load', sweep);

  // Si el foco quedo en el contenedor de un slide que esta por ocultarse, lo
  // soltamos: un div contenedor no necesita foco, y retenerlo es exactamente lo
  // que Chrome bloquea. No se toca el foco si esta en un control real de
  // adentro (link, boton), para no interrumpir al usuario.
  if (window.jQuery) {
    window.jQuery(document).on('beforeChange.slickA11y', function (e) {
      var a = document.activeElement;
      if (a && a.classList && a.classList.contains('slick-slide')) a.blur();
    });
  }
})();
